module.exports = __webpack_public_path__ + "img/chat-v2.d16bdb0c.png";